import API from '..';
const ENTITY = 'users';

export const update = (data, id) =>
    API.put(`/api/v1/${ENTITY}/${id}`, { ...data });
export const changePasswordProfile = (data) =>
    API.post(`/api/v1/${ENTITY}/change-password-profile/`, { ...data });
